import React from "react";
import { Link } from "react-router-dom";
import NewsletterSubscribeBox from "./sidebar/NewsletterSubscribeBox";
import SocialIconsBox from "./sidebar/SocialIconsBox";
import BenefitsBox from "./sidebar/BenefitsBox";
import ContactHoursBox from "./sidebar/ContactHoursBox";

function HomeCtaButtons() {
  return (
    <>
      <Link
        to="/contact"
        className="nn-cream-btn block text-center py-3 px-6 font-display tracking-wider text-lg"
      >
        Make an Appointment
      </Link>
      <Link
        to="/clinic/download-forms"
        className="nn-cream-btn block text-center py-3 px-6 font-display tracking-wider text-lg"
      >
        Patient Forms
      </Link>
    </>
  );
}

export default function Sidebar({
  showHomeButtons = false,
  sidebarBenefits = null,
  hoursAndContact = false,
}) {
  return (
    <aside className="w-full lg:w-[280px] flex-shrink-0 space-y-4">
      {showHomeButtons && <HomeCtaButtons />}
      <NewsletterSubscribeBox />
      <SocialIconsBox />
      <BenefitsBox items={sidebarBenefits} />
      {hoursAndContact && <ContactHoursBox />}
    </aside>
  );
}
